import React, { forwardRef } from 'react'

/**
 * A pill-shaped toggle button used for filter chips. Independent of
 * SegmentedToggle (which is a single-select group) — each ToggleChip
 * toggles its own boolean and reflects it via `aria-pressed`.
 *
 * Active state uses the brand-green accents; see design-language.md §2.4.
 */
export const ToggleChip = forwardRef(function ToggleChip(
  { pressed = false, onChange, disabled = false, className = '', children, ...rest },
  ref,
) {
  const classes = ['toggle-chip', className].filter(Boolean).join(' ')
  return (
    <button
      ref={ref}
      type="button"
      className={classes}
      aria-pressed={pressed}
      disabled={disabled}
      onClick={(e) => {
        rest.onClick?.(e)
        if (!e.defaultPrevented) onChange?.(!pressed)
      }}
      {...rest}
    >
      {children}
    </button>
  )
})
